import { Button, Select, Spin } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { BiPlusCircle } from "react-icons/bi";
import Swal from "sweetalert2";
import { FormulaOperation } from "./FormulaOperation";
export const FormulaForm = ({
  parameters,
  formulas,
  mode,
  data,
  onFinish = () => {},
  onCancel = () => {},
  assignFormula,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const initialState = {
    name: "",
    unit: "",
    formula: "",
    intervalPeriod: "",
    fallbackBehavior: "",
    operator: null,
    type: "system",
    description: "",
    operations: [
      {
        option: "",
        value: "",
      },
      {
        option: "",
        value: "",
      },
      {
        option: "",
        value: "",
      },
      {
        option: "",
        value: "",
      },
      {
        option: "",
        value: "",
      },
    ],
  };
  const [state, setState] = useState(initialState);

  const onInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeOperation = (index, obj) => {
    const data = Array.from(state.operations);

    data[index] = { ...data[index], ...obj };

    setState({
      ...state,
      operations: data,
    });
  };

  const onCreate = async (payload) => {
    try {
      const response = await axios.post(`/formula`, payload, {
        withCredentials: true,
      });
      if (response) {
        setState(initialState);

        await Swal.fire({
          title: "Done!",
          text: "Formula Created Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
        onFinish();
      }
    } catch {
      Swal.fire({
        title: "Done!",
        text: "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };

  const onUpdate = async (id, payload) => {
    try {
      const response = await axios.put(`/formula/${id}`, payload, {
        withCredentials: true,
      });
      if (response) {
        setState(initialState);
        Swal.fire({
          title: "Done!",
          text: "Formula Updated Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
        onFinish();
      }
    } catch {
      Swal.fire({
        title: "Done!",
        text: "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let payload = state;
    payload.operations = payload.operations.filter((d) => d.option && d.value);

    if (mode === "edit") {
      await onUpdate(data?._id, payload);
    } else {
      await onCreate(payload);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    let formula = "";
    for (const op of state.operations) {
      if (["time", "area", "year", "month"].includes(op.value)) {
        formula += " " + op.value[0].toUpperCase() + op.value.slice(1);
      } else {
        formula += " " + op.value;
      }
    }
    setState({ ...state, formula: formula.trim() });
  }, [state.operations]);

  useEffect(() => {
    if (mode === "edit" && data) {
      setState({
        name: data.name,
        unit: data.unit,
        formula: data.formula,
        type: data.type,
        operations: data.operations,
        intervalPeriod: data.intervalPeriod || "",
        fallbackBehavior: data.fallbackBehavior || "",
        operator: data.operator || "",
        description: data.description || "",
      });
    }
  }, [mode, data]);

  return (
    <Spin spinning={isLoading}>
      <div className="row mt-4">
        <div className="col-md-12">
          <h5>{mode === "edit" ? "Update Formula" : "Add A New Formula"}</h5>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col-md-6">
              <div>
                <label htmlFor="name">Formula Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={state.name}
                  onChange={onInputChange}
                  className="form-control"
                  placeholder="Enter formula name"
                  required
                />
              </div>
              {assignFormula && (
                <>
                  <div>
                    <label>Interval Period (Min)</label>
                    <input
                      type="number"
                      min={1}
                      className="form-control"
                      name="intervalPeriod"
                      value={state?.intervalPeriod || ""}
                      // onChange={onInputChange}
                      onChange={(e) => {
                        let value = Number(e.target.value || 0);
                        if (value < 1) value = 1;
                        setState({
                          ...state,
                          intervalPeriod: value,
                        });
                      }}
                      placeholder="Enter Interval Period"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="formula">Operator</label>
                    <Select
                      className="d-block"
                      size="large"
                      value={state?.operator}
                      onChange={(e) => setState({ ...state, operator: e })}
                      placeholder="Select Operator"
                      required
                    >
                      <option value="real">Real Time</option>
                      <option value="max">Maximum</option>
                      <option value="min">Minimum</option>
                      <option value="avg">Average</option>
                      <option value="sum">Sum</option>
                      <option value="differential">Differential</option>
                    </Select>
                  </div>
                  <div>
                    <label htmlFor="formula">Action On Data Not Found</label>
                    <Select
                      className="d-block"
                      size="large"
                      name="fallbackBehavior"
                      value={state?.fallbackBehavior || null}
                      onChange={(e) => setState({ ...state, fallbackBehavior: e })}
                      required
                      placeholder="Select Action"
                    >
                      <option value={"Zero(0)"}>Zero(0)</option>
                      <option value={"Skip"}>Skip</option>
                    </Select>
                  </div>
                </>
              )}
              <div>
                <label htmlFor="unit">Formula Unit / Value</label>
                <input
                  type="text"
                  id="unit"
                  name="unit"
                  value={state.unit}
                  onChange={onInputChange}
                  className="form-control"
                  placeholder="Enter formula Unit"
                  required
                />
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="unit">Description</label>
              <textarea
                style={{ resize: "none" }}
                id="description"
                name="description"
                value={state.description || ""}
                onChange={onInputChange}
                className="form-control"
                placeholder="Enter description"
                rows={3}
              />
            </div>
          </div>

          <div>
            <label htmlFor="name">
              Set Formula
              <Button
                className="ms-2"
                type="primary"
                icon={<BiPlusCircle />}
                iconPosition="end"
                size="sm"
                onClick={() => {
                  setState({
                    ...state,
                    operations: [...state.operations, { option: "", value: "" }],
                  });
                }}
              >
                <span style={{ fontSize: 12 }}>Add More</span>
              </Button>
            </label>
            <div style={{ display: "flex", flex: 1, overflowX: "auto", paddingTop: 15, paddingBottom: 15 }}>
              <div
                className=" gap-3"
                style={{
                  display: "flex",
                }}
              >
                {state.operations.map((op, index) => (
                  <FormulaOperation
                    key={index}
                    closeable={index > 2}
                    onClose={() => {
                      const data = Array.from(state.operations);
                      data.splice(index, 1);
                      setState({
                        ...state,
                        operations: data,
                      });
                    }}
                    onChange={(obj) => onChangeOperation(index, obj)}
                    operation={op}
                    parameters={parameters}
                    formulas={formulas}
                    width={["parameter", "formula"].includes(op.option) ? "300px" : "150px"}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="row mt-3 mb-3">
            <div className="col-md-12">
              <label htmlFor="" className="me-3">
                Formula Preview
              </label>
              {state.name && state.formula && (
                <b>
                  {state.name} = {state.formula}
                </b>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
            <Button
              type="primary"
              size="sm"
              htmlType="submit"
              disabled={
                state.operations?.length < 3 ||
                state.operations?.some((item) => !item?.option || !item?.value) ||
                !state?.unit ||
                !state?.name
              }
            >
              {mode === "edit" ? "Update" : "Create"} Formula
            </Button>

            <Button
              type="primary"
              size="sm"
              className="bg-secondary"
              onClick={(e) => {
                e.preventDefault();
                onCancel();
              }}
              htmlType="button"
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </Spin>
  );
};

FormulaForm.propTypes = {
  parameters: PropTypes.array,
  formulas: PropTypes.array,
  mode: PropTypes.string,
  data: PropTypes.object,
  onFinish: PropTypes.func,
  onCancel: PropTypes.func,
  assignFormula: PropTypes.bool,
};
